var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprovalLine = function SvgApprovalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "var(--icon-stroke-width, 1.2)",
    d: "M5.333 16c5.905.001 13.524-11.429 7.81-12.571-6.035-1.206-6.286 21.142 1.714 10.857 1.755-2.256.571 2.857 1.714 2.285l1.714-1.143M2.035 20.568H21.75"
  })));
};
export default SvgApprovalLine;